<template>
  <div style="width: 100%;height: calc(100vh - 150px)">
    <w-personal-plan-index></w-personal-plan-index>
  </div>
</template>
<script>
export default {
  name: "PersonalPlan",
  data(){
    return{
      personalIframeSrc:window.location.origin+'/personalPlanComponent'
    }
  },
}
</script>

<style scoped>

</style>
